import type React from 'react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { PROMO_SLOT_PRIORITIES } from '../global-promo-slot/promo-slot-priorities';
import { usePromoSlotEntry } from '../global-promo-slot/use-promo-slot-entry';
import { AUTOMATIONS_RULES_PATH } from '../../routes/constants';
import { CHEAPEST_RATE_SHOPPER_RULE } from '../../pages/automations/components/automation-playbooks/playbooks';

import { RateShopperPopupCard } from './popup-card';
import { useRateShopperPopupDismissalState, useShouldShowRateShopperPopup } from './use-should-show-rate-shopper-popup';

export const AutomationRateShopperPopup: React.FC = () => {
  const isEligible = useShouldShowRateShopperPopup();
  const { shouldRender } = usePromoSlotEntry({
    id: 'rate-shopper-popup',
    priority: PROMO_SLOT_PRIORITIES.RATE_SHOPPER_POPUP,
    shouldShow: isEligible,
  });
  const navigate = useNavigate();
  const { snooze, snoozePermanently } = useRateShopperPopupDismissalState();

  const handleAddRule = useCallback(() => {
    snoozePermanently();
    navigate(AUTOMATIONS_RULES_PATH, {
      state: { openPlaybookRule: CHEAPEST_RATE_SHOPPER_RULE },
    });
  }, [snoozePermanently, navigate]);

  if (!shouldRender) return null;

  return <RateShopperPopupCard onAddRule={handleAddRule} onSnooze={snooze} />;
};
